import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Copy } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { formatDuration } from "@air/utilities";
import { memo } from "react";
export const TranscriptSegmentHeader = /*#__PURE__*/ memo((param)=>{
    let { segment, onCopyTextClick } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "select-none text-12 text-grey-11",
                children: formatDuration(segment.startTimeMs / 1000)
            }),
            /*#__PURE__*/ _jsx(Button, {
                onClick: onCopyTextClick,
                prefix: /*#__PURE__*/ _jsx(Copy, {
                    className: "size-2.5"
                }),
                size: "extra-small",
                color: "grey",
                className: "opacity-0 group-hover/segment:opacity-100",
                children: "Copy"
            })
        ]
    });
});
TranscriptSegmentHeader.displayName = "TranscriptSegmentHeader";
